import React, {Component} from 'react';
import {Route} from 'react-router-dom';
import {Home} from './components/Home';
import {Iframe} from "./components/Iframe";
import {AppWebView} from "./components/AppWebView";



export default class App extends Component {
    static displayName = App.name;

    render() {
        const urlParams = new URLSearchParams(window.location.search.replace('?', ''));
        const businessId = urlParams.get('businessId') || urlParams.get('locationid'); 
        const priceId = urlParams.get('priceId') || ''; 
        const appToken = urlParams.get('token') || urlParams.get('appToken');
        const temporaryToken = urlParams.get('temporaryToken');
        const cancelUrl = urlParams.get('cancelUrl');
        return (
        <React.Fragment>
            <Route exact path='/' render={() => <Home businessId={businessId} priceId={priceId} appToken={appToken} />}/>
            <Route exact path='/iframe' render={() => <Iframe businessId={businessId} priceId={priceId} />}/>
            <Route exact path='/app' render={() => <AppWebView businessId={businessId} priceId={priceId} temporaryToken={temporaryToken} cancelUrl={cancelUrl} />}/>
        </React.Fragment>
        );
    }
}
